import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { BrandLockup } from "@/components/BrandLockup";

const ROLES = [
  ["geologist", "Geologist"], ["remote_sensing_specialist", "Remote-Sensing Specialist"],
  ["gis_analyst", "GIS Analyst"], ["mining_engineer", "Mining Engineer"],
  ["reviewer", "Reviewer"], ["client_viewer", "Client Viewer"], ["company_admin", "Company Admin"],
];

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "geologist" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e?.target ? e.target.value : e });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await register(form);
      if (res?.pending) {
        toast.success("Account created - a Super Admin must approve it before you can sign in.", { duration: 8000 });
        nav("/login");
      } else {
        toast.success("Account created");
        nav("/console");
      }
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6 animate-fade-in">
        <BrandLockup />
        <div>
          <p className="overline">Create account</p>
          <h2 className="font-display text-2xl font-bold tracking-tight mt-1">Join the exploration platform</h2>
        </div>
        <div className="space-y-3">
          <div><Label>Full name</Label>
            <Input data-testid="reg-name" value={form.name} onChange={set("name")} required className="mt-1" /></div>
          <div><Label>Email</Label>
            <Input data-testid="reg-email" type="email" value={form.email} onChange={set("email")} required className="mt-1" /></div>
          <div><Label>Password</Label>
            <Input data-testid="reg-password" type="password" value={form.password} onChange={set("password")} required className="mt-1" /></div>
          <div><Label>Role</Label>
            <Select value={form.role} onValueChange={set("role")}>
              <SelectTrigger data-testid="reg-role" className="mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>
                {ROLES.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>
        <Button type="submit" data-testid="reg-submit" disabled={loading} className="w-full">
          {loading ? "Creating…" : "Create account"}
        </Button>
        <p className="text-sm text-muted-foreground text-center">
          Have an account? <Link to="/login" className="text-primary hover:underline" data-testid="go-login">Sign in</Link>
        </p>
      </form>
    </div>
  );
}
